import { useEffect } from 'react';
import { useStoreApi } from '../store';
import { isTypingTarget, matchesKey } from '../utils';

/** `deleteKeyCode` deletes the selection, unless the key was pressed while typing (v11). */
export const useDeleteKey = (): void => {
  const store = useStoreApi();
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const { deleteKeyCode, deleteSelected } = store.getState();
      if (isTypingTarget(event.target) || !matchesKey(event, deleteKeyCode)) return;
      deleteSelected();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [store]);
};
